// Stub notification system - notifications are handled by sonner/toast
export default function NotificationSystem() {
  return null;
}
